import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=2aec4416&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=js&"
export * from "./DetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=2aec4416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec4416",
  null
  
)

export default component.exports